/**
 * TD-28 D-24/D-25: 項目表示制御の語彙。
 * ⚠️ §8-55 対策: 設定画面 (RequestFieldVisibilitySettingsPage) と申請画面 (RequestsPage) の
 * 2箇所に別々の語彙を置くと、同じ概念が画面ごとに違う言葉で表示される。ここ1箇所に集約する。
 * サーバー側の許容値は apps/api/src/lib/request-instances/field-visibility.ts の zod enum が正典。
 */

/** 表示段階 (none | exists_only | full)。設定画面で「何段階まで見せるか」を選ぶときの文言。 */
export const FIELD_DISPLAY_LEVEL_LABEL: Record<string, string> = {
  none: '表示しない',
  exists_only: '項目名のみ（値は伏せる）',
  full: 'すべて表示',
};

/** 表示コンテキスト。設定画面では「どの場面か」、申請画面では「いまどの立場で見ているか」を表すため
 *  用途別に2種類の言い回しを持つ (同じ概念だが文の位置が違う)。 */
export const FIELD_CONTEXT_LABEL: Record<string, string> = {
  self: '申請者本人',
  approver: '承認者',
  viewer: 'その他の閲覧者',
};

export const FIELD_CONTEXT_VIEWING_LABEL: Record<string, string> = {
  self: '申請者としての表示',
  approver: '承認者としての表示',
  viewer: '閲覧者としての表示',
};
